import React, { useEffect, useState } from 'react'
// import axios from 'axios'
import axios from '../../AxiosConfig.js'
import { useLocation } from 'react-router-dom';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Row, Col, Card, Button, Form, Accordion, InputGroup, Dropdown } from 'react-bootstrap'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import job5 from '../images/jobs/job6.png'
import { createJobApplication, fetchJobData, getAllJobs, fetchAllJobRoles, getOldAndNewJobroles, getAllFakeJobs, handelOpenToWork } from '../../features/constants/apis'
import { connect } from 'react-redux'
import { setToken } from '../../features/auth/authSlice'
import { postNewJob } from '../../features/constants/apis'
import { setSelectedJob } from "../../features/data/selectedDriveSlice.js";
import ShimmerJobs from './Shimmer/ShimmerJobs.js';
import { Link } from 'react-router-dom';
import { IoFunnel, IoFunnelOutline } from "react-icons/io5";
import { FaArrowLeft } from 'react-icons/fa';
import JobListCard from './JobListCard.js';
import UserCardList from './UserCardList.js';
import ServerSide from '../layout/ServerSide/ServerSide.js';
import CandidateCard from './Cards/CandidateCard.js';
import ControlsSearch from '../../components/layout/ServerSide/components/ControlsSearch.js';
import { useTable, useGlobalFilter, useSortBy, usePagination, useRowSelect, useRowState, useAsyncDebounce } from 'react-table';
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import VerifiedBlueLogo from '../images/VerifiedBlueLogoMark.svg'
import NotVerifiedBlueLogo from '../images/NotVerifiedGreyLogoMark.svg'
import filterCheckmark from '../images/candidate-login/checkmark-scopehai-small.png'

function EmpCandidateList({ authToken, role, ID, setSelectedJob }) {

    const navigate = useNavigate();

    const [totalCount, setTotalCount] = useState();

    // Validation
    const [validated, setValidated] = useState(false);
    const [allJobs, setAllJobs] = useState([]);
    const [allFakeJobs, setAllFakeJobs] = useState([]);
    const [isNewJob, setIsNewJob] = useState(false);
    const [jobData, setJobData] = useState([])

    const [jobImage, setJobImage] = useState('');
    const [jobTitle, setJobTitle] = useState('');
    const [jobType, setJobType] = useState(null);
    const [jobLocation, setJobLocation] = useState(null)
    const [jobCtc, setJobCtc] = useState(null)
    const [numValueOpenings, setNumValueOpenings] = useState('')
    const [jobEducation, setJobEducation] = useState(null)
    const [buttonDisableID, setButtonDisableID] = useState([])
    const [expandedItem, setExpandedItem] = useState(null);
    const [year, setYear] = useState(false);
    const [salary, setSalary] = useState(false);
    const [maxCtc, setMaxCtc] = useState(null);
    const [location, setLocation] = useState(null);
    const [immediate, setImmediate] = useState(false);
    const [fullTime, setFullTime] = useState(false);
    const [partTime, setPartTime] = useState(false);
    const [internship, setInternship] = useState(false);
    const [remote, setRemote] = useState(false);
    const [onSite, setOnSite] = useState(false);
    const [disableFilter, setDisableFilter] = useState(true);
    const [jobRoles, setJobRoles] = useState([]);
    const [expStatus, setExpStatus] = useState(null);
    const [allLocations, setAllLocations] = useState(null);


    const [candidateSearch, setCandidateSearch] = useState('');

   const clearFilters = () => {
        setCandidateSearch('');
        setYear(false);
        setSalary(false);
        setImmediate(false);
        setTerm('');
        setSearchTitle('');
        setIsVsp(false);
        setLocation(null);
        setMaxCtc(null);
        setFullTime(false);
        setPartTime(false);
        setInternship(false);
        setRemote(false);
        setOnSite(false);
        setExpStatus(null);
    }


    console.log(candidateSearch)
    const toggleAccordion = (idx) => {
        if (expandedItem === idx) {
            setExpandedItem(null);
        } else {
            setExpandedItem(idx);
        }
    };

    const handleInputTitle = (event) => {
        setJobTitle(event.target.value);
    };
    const handleInputOpenings = (event) => {
        const newNumValue = event.target.value.replace(/\D/g, '');
        setNumValueOpenings(newNumValue);
    };


    useEffect(() => {
        const jobByID = async () => {
            const response = await fetchJobData(112, authToken);
            console.log(response)
        }
        jobByID();
    }, [])

    // useEffect(() => {
    //     const fetchAllJobs = async () => {
    //         const data = await getAllJobs(authToken);
    //         // const filteredJobs = data.data.filter(job => job.PlacementDriveID === null)
    //         setAllJobs(data.data);
    //         console.log(data.data)
    //         // console.log(filteredJobs.length)
    //         // console.log(ID)
    //     }
    //     fetchAllJobs();
    // }, [authToken]);

    useEffect(() => {
        const fetchAllFakeJobs = async () => {
            const data = await getAllFakeJobs(authToken);
            // const filteredJobs = data.data.filter(job => job.PlacementDriveID === null)
            // setAllFakeJobs(data.data);
            // console.log(data.data)
            // console.log(filteredJobs.length)
            console.log(ID)
        }
        fetchAllFakeJobs();
    }, [authToken]);



    const uploadRefImage = (filePath) => {
        // const tempCustomOrderObj2 = JSON.parse(JSON.stringify(tempCustomOrderObj))
        const formData = new FormData();
        formData.append('inputFile', filePath)
        axios.post('https://api.webweb.ai/website/upload/scopehai', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).then(res => {
            console.log(res)
            // setImagePreview(res.data.data)
            // tempCustomOrderObj2.ReferenceImage = res.data.data
            // tempCustomOrderObj2.OrderDetails.ReferenceImage = res.data.data
            // setTempCustomOrderObj(tempCustomOrderObj2)
        }).catch(err => {
        })
    }


    const handleAddNewJob = () => {
        // setIsNewJob(true);

        console.log("true")
        navigate(`/new-job-form`)
    }
    const handelOpenToWork = async () => {
        const join = 'join';
        const openToWork = await handelOpenToWork(join, authToken)
        console.log(openToWork)
    }

    const handleSaveClick = (event) => {
        // Perform save action here (e.g., update backend)
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);

        if (form.checkValidity() === true) {
            // Proceed with saving the job if the form is valid
            const newJobFormData = {
                'JobTitle': jobTitle,
                'JobType': jobType,
                'JobLocation': jobLocation,
                'JobCTC': jobCtc,
                'OpenPositions': numValueOpenings,
                'EducationRequirement': jobEducation,
                'tokenUserID': ID
            }

            const newJob = async () => {
                const newJobData = await postNewJob(newJobFormData, authToken)
                console.log(newJobData)
            }

            newJob();
            setIsNewJob(false);
        }
        setIsNewJob(true);
    };

    const handleCancelClick = () => {
        setJobImage('')
        setJobTitle('')
        setJobType(null)
        setJobCtc(null)
        setJobEducation(null)
        setJobLocation(null)
        setNumValueOpenings('')
        setIsNewJob(false);
    }

    const handleViewJobDetails = (job) => {
        navigate(`/job-details?Job=${job}`)
    }


    const notify = async (ar, index) => {

        setButtonDisableID([...buttonDisableID, index]);

        console.log(ar?.ID, ID, ar?.EmployerID)

        const applicationData = {
            'JobID': ar?.ID,
            'EmpID': ar?.EmployerID,
            'JobTitle': ar?.Title,
            'tokenUserID': ID,
        }

        const jobs = async () => {
            const jobData = await createJobApplication(applicationData, authToken)
            console.log(jobData)

            if (jobData?.data === "Job appliation created successfully!") {
                toast.success('Your Skill profile has been shared with the recruiter!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light"
                })
            }
            // console.log(jobData?.data)
        }
        jobs()
    };

    // console.log(allJobs)

    const [activeKey, setActiveKey] = useState(null);

    const handleToggleAccordion = () => {
        setActiveKey(activeKey === '0' ? null : '0');
    };

    // const handleSearch = (value) => {
    //     setCandidateSearch(value)
    // }

    const [isVsp, setIsVsp] = useState(false);
    const [isOpenToSwitch, setIsOpenToSwitch] = useState(false);


    console.log("handelOpenToVsp value: ", isOpenToSwitch);
    const handelOpenToVsp = () => {
        console.log("hendel open to Vsp triggerd !");
        setIsVsp((prevState) => !prevState);
        console.log("handelOpenToVsp: ", isOpenToSwitch);
    }

    console.log('is vsp status: ', isVsp);

    const handelaYear = () => {
        setYear((prevState) => !prevState);
    }

    console.log('years :', year);

    const [data, setData] = useState([]);
    const [pageCount, setPageCount] = React.useState(3);
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false);
    const [term, setTerm] = useState(String);
    const [searchTitle, setSearchTitle] = useState(String);
    console.log(term)

    const searchItem = useAsyncDebounce((val) => {
        setTerm(val || undefined);
    }, 200);

    const columns = React.useMemo(() => {
        return [
            {
                Header: 'ID',
                accessor: 'ID',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'ID', // Assign a unique id
                width: 50, // Optional width for the column header
                Cell: ({ row }) => {
                    const { ID } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {ID}
                        </span>
                    );
                },
            },
            {
                Header: 'Role',
                accessor: 'RoleID',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'RoleID', // Assign a unique id
                width: 110, // Optional width for the column header
                Cell: ({ row }) => {
                    const { RoleID } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {RoleID}
                        </span>
                    );
                },
            },




            //////////////////////////////////////////
            // {
            //   name: 'Remarks',
            //   selector: (row) => (
            //     <Button
            //       variant={row.VspStatus ? 'outline-primary' : 'primary'}
            //       size="sm"
            //       onClick={() => handelOpenModal(row.ID, row.UserId, row.VspStatus)}
            //     // disabled={row.VspStatus}
            //     >
            //       {row.VspStatus ? 'Verified' : 'Pending'}
            //     </Button>
            //   ),
            //   width: '120px',
            //   margin: "20px"
            // },



            {
                Header: 'Name',
                accessor: 'FullName',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'FullName', // Assign a unique id
                width: 110,
                Cell: ({ row }) => {
                    const { FullName, ID } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={() => {
                                navigate(`/candidate-profile-ro?candidateID=${ID}`);
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {FullName}
                        </span>
                    );
                },
            },

            /////////////////////////////////////////////////////////////////////

            // {
            //   Header: 'Name',
            //   accessor: 'FullName',
            //   sortable: true,
            //   headerClassName: 'text-muted text-small text-uppercase text-nowrap',
            //   id: 'FullName', // Assign a unique id
            //   width: 110,
            //   Cell: ({ row }) => {
            //     const { FullName } = row.original
            //     return (
            //       <span
            //         className="list-item-heading body text-wrap cursor-pointer"
            //         onClick={(e) => {
            //           e.preventDefault();
            //         }}
            //         style={{ fontSize: '14px' }}
            //       >
            //         {FullName}
            //       </span>
            //     );
            //   },
            // },
            {
                Header: 'Phone',
                accessor: 'Phone',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'Phone', // Assign a unique id
                width: 160,
                Cell: ({ row }) => {
                    const { Phone } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {Phone}
                        </span>
                    );
                },
            },
            {
                Header: 'Email',
                accessor: 'Email',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'Email', // Assign a unique id
                width: 220,
                Cell: ({ row }) => {
                    const { Email } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {Email}
                        </span>
                    );
                },
            },
            {
                Header: 'Experience Level',
                accessor: 'ExperienceLevel',
                sortable: true,
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'ExperienceLevel', // Assign a unique id
                width: 150,
                Cell: ({ row }) => {
                    const { ExperienceLevel } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {ExperienceLevel}
                        </span>
                    );
                },
            },
            {
                Header: 'Education',
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'Education', // Assign a unique id
                width: 150,
                Cell: ({ row }) => {
                    const { CareerProfile } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {CareerProfile?.education}
                        </span>
                    );
                },
            },
            {
                Header: 'Degree',
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'Degree', // Assign a unique id
                width: 80,
                Cell: ({ row }) => {
                    const { CareerProfile } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {CareerProfile?.degree}
                        </span>
                    );
                },
            },
            {
                Header: 'General Skills',
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'GSkills', // Assign a unique id
                width: 250,
                Cell: ({ row }) => {
                    const { SkillProfile } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ wordBreak: 'break-all', fontSize: '14px' }}
                        >
                            {SkillProfile?.GeneralSkills?.toString()}
                        </span>
                    );
                },
            },
            {
                Header: 'Professional Skills',
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'PSkills', // Assign a unique id
                width: 250,
                Cell: ({ row }) => {
                    const { SkillProfile } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ wordBreak: 'break-all', fontSize: '14px', color: '#333333' }}
                        >
                            {SkillProfile?.ProfessionalSkills?.toString()}
                        </span>
                    );
                },
            },
            {
                Header: 'Certifications',
                headerClassName: 'text-muted text-small text-uppercase text-nowrap',
                id: 'Certificate', // Assign a unique id
                width: 130,
                Cell: ({ row }) => {
                    const { SkillProfile } = row.original
                    return (
                        <span
                            className="list-item-heading body text-wrap cursor-pointer"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                            style={{ fontSize: '14px' }}
                        >
                            {SkillProfile?.Certificate}
                        </span>
                    );
                },
            },
        ];
    }, []);

    const tableInstance = useTable(
        {
            columns,
            data,
            setData,
            isOpenAddEditModal,
            setIsOpenAddEditModal,
            manualPagination: true,
            manualFilters: true,
            manualSortBy: true,
            autoResetPage: false,
            autoResetSortBy: false,
            pageCount,
            initialState: { pageIndex: 0, sortBy: [{ id: 'ID', desc: false }], hiddenColumns: ['id'] },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect,
        useRowState
    );
    const {
        state: { pageIndex, pageSize, sortBy }, gotoPage
    } = tableInstance;


    /////////////////////////////////////SERCH BAR FUNC///////////////////////////////////////
    const handleSearch = (value) => {
        gotoPage(0);
        setCandidateSearch(value);
        // setTerm(value); // Update the `term` state
        // fetchData(); // Trigger fetchData when search input changes
    };

    const searchTrigger = () => {
        console.log('search button clicked')
        if (candidateSearch != '' && candidateSearch != null && candidateSearch != undefined) {
            setTerm(term);
            setSearchTitle(candidateSearch);
        }
    }

    useEffect(() => {
        // if (searchTitle || term || isVsp || year || salary || immediate || expStatus || maxCtc || location || fullTime || partTime || internship || remote || onSite) {
        if (role !== 'C-Partner') {
            navigate(`/emp-candidate-list?${(term) ? `term=${term}` : ''}${(searchTitle) ? `&searchTitle=${searchTitle}` : ''}&sortBy[]=[{"id":"ID","desc":true}]&pageSize=${pageSize}&pageIndex=${pageIndex}&${(isVsp) ? `isVsp=${isVsp}` : ''}${(year) ? `&year=${year}` : ''}${(salary) ? `&salary=${salary}` : ''}${(immediate) ? `&immediate=${immediate}` : ''}${(expStatus) ? `&expStatus=${expStatus}` : ''}${(maxCtc) ? `&maxCtc=${maxCtc}` : ''}${(location) ? `&location=${location}` : ''}${(fullTime) ? `&fullTime=${fullTime}` : ''}${(partTime) ? `&partTime=${partTime}` : ''}${(internship) ? `&internship=${internship}` : ''}${(remote) ? `&remote=${remote}` : ''}${(onSite) ? `&onSite=${onSite}` : ''}`)
        } else {
            navigate(`/course-candidate-list`)
        }
        // }
    }, [searchTitle, term, isVsp, year, salary, immediate, expStatus, maxCtc, location, fullTime, partTime, internship, remote, onSite])

    useEffect(() => {
        if (candidateSearch != '' && candidateSearch != null && candidateSearch != undefined) {
            setDisableFilter(false);
        } else {
            searchTrigger();
            setDisableFilter(true);
        }
    }, [candidateSearch])
    const handleDataFromChild = (data) => {
        console.log("Data received from child:", data);
        setTotalCount(data);
    };


    useEffect(() => {
        const fetchJobRoles = async () => {
            const data = await getOldAndNewJobroles(authToken)
            setJobRoles(data.data)
            // setCandidateSearch(data.data)
        }
        fetchJobRoles()
        const fetchAllLocations = async () => {
            const response = await axios.get(`/locations/get-all-location`);
            setAllLocations(response.data.data)
        }
        fetchAllLocations()
    }, [])

    const handleChange = (selectedOption) => {
        setTerm(selectedOption ? selectedOption.value : ""); // Store ID
        setSearchTitle(selectedOption ? selectedOption.label : ""); // Store Title
        setCandidateSearch(selectedOption?.label);
    };

    const [searchParams] = useSearchParams();
    useEffect(async () => {

        const term = searchParams.get("term");
        const searchTitle = searchParams.get("searchTitle");
        const sortBy = searchParams.get("sortBy[]");
        const pageSize = searchParams.get("pageSize");
        const pageIndex = searchParams.get("pageIndex");
        const isVsp = searchParams.get("isVsp");
        const year = searchParams.get("year");
        const salary = searchParams.get("salary");
        const maxCtc = searchParams.get("maxCtc");
        const location = searchParams.get("location");
        const immediate = searchParams.get("immediate");
        const fullTime = searchParams.get("fullTime");
        const partTime = searchParams.get("partTime");
        const internship = searchParams.get("internship");
        const remote = searchParams.get("remote");
        const onSite = searchParams.get("onSite");
        const expStatus = searchParams.get("expStatus");
        const tempCheckboxFilters = searchParams.get("checkboxFilters")

        setImmediate(JSON.parse(immediate))
        setFullTime(JSON.parse(fullTime))
        setTerm(term)
        setIsVsp(isVsp)
        setSearchTitle(searchTitle)
        setLocation(location)
        setMaxCtc(maxCtc)
        setYear(year)
        setPartTime(partTime)
        setInternship(internship)
        setRemote(remote)
        setOnSite(onSite)
        setExpStatus(expStatus)
        console.log(JSON.parse(immediate))
    }, []);



    return (
        <div id="appCapsule" style={{ backgroundColor: '#ffffff' }}>
            <div style={{ backgroundColor: '#f5f5f5' }}>
                <div className='container'>
                    <div class="pt-2 d-flex">

                        <InputGroup className="mb-1 me-1">
                            {/* <InputGroup.Text id="basic-addon1" className='w-auto ps-1' style={{ background: '#ffffff', border: '1px solid gainsboro', height: '36px' }}>
                                <ion-icon name="search-outline"></ion-icon>
                            </InputGroup.Text> */}
                            {/* <Select
                                options={jobRoles?.map((role) => ({ value: role.ID, label: role.Title }))} // Pass the options
                                onChange={(selectedOption) => setTerm(selectedOption?.value)}
                                value={jobRoles?.find((option) => option?.value === term)}
                                placeholder="Search for a job position"
                                aria-label="Search"
                                aria-describedby="basic-addon1"
                                // value={candidateSearch}
                                // onChange={(e) => { handleSearch(e.target.value) }}
                                style={{ borderLeft: 'none', borderColor: 'gainsboro', borderRight: (candidateSearch) ? 'none' : 'solid 1px gainsboro', height: '36px' }}
                            /> */}
                            {/* <Form.Control
                                placeholder="Search for a job position"
                                aria-label="Search"
                                aria-describedby="basic-addon1"
                                value={candidateSearch}
                                onChange={(e) => { handleSearch(e.target.value) }}
                                style={{ borderLeft: 'none', borderColor: 'gainsboro', borderRight: (candidateSearch) ? 'none' : 'solid 1px gainsboro', height: '36px' }}
                            /> */}
                            <CreatableSelect
                                options={jobRoles?.map((role) => ({ value: role.ID, label: role.Title }))}
                                onChange={handleChange}
                                value={
                                    term
                                        ? { value: term, label: searchTitle || jobRoles.find((role) => role.ID === term)?.Title || term }
                                        : null
                                }
                                getOptionLabel={(e) => e.label}
                                getOptionValue={(e) => e.value}
                                placeholder="Search for a job position"
                                aria-label="Search"
                                aria-describedby="basic-addon1"
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderLeft: "none",
                                        borderColor: "gainsboro",
                                        borderRight: term ? "none" : "solid 1px gainsboro",
                                        height: "36px",
                                    }),
                                }}
                            />
                            {/* {candidateSearch &&
                                <InputGroup.Text id="basic-addon1" className='w-auto pe-1' onClick={() => { setCandidateSearch(''); setYear(false); setSalary(false); setImmediate(false); setTerm(''); }} style={{ background: '#ffffff', border: '1px solid gainsboro', borderLeft: 'none', cursor: 'pointer', height: '36px' }}>
                                    <ion-icon name="close-outline"></ion-icon>
                                </InputGroup.Text>
                            } */}
                        </InputGroup>
                        <Button variant='secondary-outline' onClick={() => { clearFilters() }} style={{ background: 'white', border: '1px solid gainsboro', height: '36px' }}>
                            <ion-icon name="close-outline" class="me-0 text-secondary"></ion-icon>
                        </Button>

                        {/* <Button variant='secondary-outline' onClick={() => { searchTrigger() }} style={{ background: 'white', border: '1px solid gainsboro', height: '36px' }}>
                            <ion-icon name="search-outline" class="me-0 text-secondary"></ion-icon>
                        </Button> */}
                    </div>
                    <InputGroup>
                        {/* <InputGroup.Text id="basic-addon1" className='w-auto ps-1' style={{ background: '#ffffff', border: '1px solid gainsboro', height: '36px' }}>
                            <ion-icon name="search-outline"></ion-icon>
                        </InputGroup.Text> */}
                        {/* <ControlsSearch tableInstance={tableInstance} onChange={searchItem} className /> */}
                    </InputGroup>


                    <div class="d-flex w-100 overflow-scroll">
                        <Dropdown>
                            <Button variant="primary-outline" className="btn btn-outline-primary text-nowrap text-black me-1" style={{ background: 'white', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                <Dropdown.Toggle variant="primary-outline" className="btn btn-outline-primary text-nowrap text-black me-1 border-0" id="dropdown-basic" style={{ background: 'transparent', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                    {(expStatus) ? expStatus : 'Select Experience'} <ion-icon name="chevron-down-outline" class="fs-6 me-0" style={{ paddingTop: '2px', marginLeft: '3px' }}></ion-icon>
                                </Dropdown.Toggle>
                            </Button>

                            <Dropdown.Menu className="position-fixed" style={{ position: 'fixed', maxHeight: '250px', overflow: 'scroll' }}>
                                <Dropdown.Item className="text-danger" onClick={() => { setExpStatus(null) }} style={{ borderBottom: '1px solid gainsboro' }}>Remove filter</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setExpStatus('Fresher') }}>Fresher</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setExpStatus('Fresher with Certification') }}>Fresher with Certification</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setExpStatus('1-3 Yrs') }}>1-3 Yrs</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setExpStatus('3-5 Yrs') }}>3-5 Yrs</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setExpStatus('5 Yrs Above') }}>5 Yrs Above</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Button variant="primary-outline" className="btn btn-outline-primary text-nowrap text-black me-1" style={{ background: 'white', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                <Dropdown.Toggle variant="primary-outline" className="btn btn-outline-primary text-nowrap text-black me-1 border-0" id="dropdown-basic" style={{ background: 'transparent', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                    {(maxCtc) ? maxCtc : 'Select'} Salary <ion-icon name="chevron-down-outline" class="fs-6 me-0" style={{ paddingTop: '2px', marginLeft: '3px' }}></ion-icon>
                                </Dropdown.Toggle>
                            </Button>

                            <Dropdown.Menu className="position-fixed" style={{ position: 'fixed', maxHeight: '250px', overflow: 'scroll' }}>
                                <Dropdown.Item className="text-danger" onClick={() => { setMaxCtc(null) }} style={{ borderBottom: '1px solid gainsboro' }}>Remove filter</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('10-20k') }}>10-20k</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('21-30k') }}>21-30k</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('31-40k') }}>31-40k</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('41-50k') }}>41-50k</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('51-60k') }}>51-60k</Dropdown.Item>
                                <Dropdown.Item onClick={() => { setMaxCtc('60k Above') }}>60k Above</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Button variant={'primary-outline'} className="btn btn-outline-primary text-nowrap text-black me-1" style={{ background: 'white', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                <Dropdown.Toggle variant={'primary-outline'} className="btn btn-outline-primary text-nowrap text-black me-1 border-0" id="dropdown-basic" style={{ background: 'transparent', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>
                                    {(location) ? location : 'Select Location'} <ion-icon name="chevron-down-outline" class="fs-6 me-0" style={{ paddingTop: '2px', marginLeft: '3px' }}></ion-icon>
                                </Dropdown.Toggle>
                            </Button>

                            <Dropdown.Menu className="position-fixed" style={{ position: 'fixed', maxHeight: '250px', overflow: 'scroll' }}>
                                <Dropdown.Item className="text-danger" onClick={() => { setLocation(null) }} style={{ borderBottom: '1px solid gainsboro' }}>Remove filter</Dropdown.Item>
                                {allLocations?.map((v, k) => {
                                    return (
                                        <Dropdown.Item onClick={() => { setLocation(v.Location) }}>{v.Location}</Dropdown.Item>
                                    )
                                })}
                            </Dropdown.Menu>
                        </Dropdown>

                        <input type="checkbox" class="btn-check" id="btn-check-3-outlined" autocomplete="off" onClick={() => { setImmediate((prevState) => !prevState) }} checked={immediate} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-3-outlined" style={{ background: '#dbeafe', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(immediate) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;Immediate Joiner</label>

                        {/* <input type="checkbox" class="btn-check" id="btn-check-4-outlined" autocomplete="off" />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-4-outlined" style={{ background: 'white', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>Mumbai</label> */}

                        <input type="checkbox" class="btn-check" id="btn-check-5-outlined" autocomplete="off" onClick={() => { setFullTime((prevState) => !prevState) }} checked={fullTime} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-5-outlined" style={{ background: '#f3e8ff', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(fullTime) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;Full Time</label>

                        <input type="checkbox" class="btn-check" id="btn-check-6-outlined" autocomplete="off" onClick={() => { setPartTime((prevState) => !prevState) }} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-6-outlined" style={{ background: '#dcfce7', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(partTime) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;Part Time</label>

                        <input type="checkbox" class="btn-check" id="btn-check-7-outlined" autocomplete="off" onClick={() => { setInternship((prevState) => !prevState) }} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-7-outlined" style={{ background: '#dbeafe', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(internship) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;Internship</label>

                        <input type="checkbox" class="btn-check" id="btn-check-8-outlined" autocomplete="off" onClick={() => { setRemote((prevState) => !prevState) }} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-8-outlined" style={{ background: '#f3e8ff', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(remote) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;Remote</label>

                        <input type="checkbox" class="btn-check" id="btn-check-9-outlined" autocomplete="off" onClick={() => { setOnSite((prevState) => !prevState) }} />
                        <label class="btn btn-outline-primary text-nowrap text-black me-1 custom-btn-checkbox" for="btn-check-9-outlined" style={{ background: '#dcfce7', border: '1px solid gainsboro', borderRadius: '5px', height: '36px' }}>{(onSite) ? <img src={filterCheckmark} width="20px" /> : ''}&nbsp;On-Site</label>
                    </div>
                </div>
            </div>

            <div className="container mt-2" style={{ backgroundColor: '#ffffff' }} >
                <div class="row mt-2">
                    <div class="col-6 col-md-6 d-flex align-items-center">
                        <h3 className="mb-0">Candidates found</h3>
                        {/* {totalCount} */}
                    </div>
                    <div class="col-6 col-md-6">
                        <form>
                            <div key={`default-checkbox`} className="d-flex justify-content-end">
                                <div className="me-1" style={{ border: 'solid 1px gainsboro', borderRadius: '5px' }}>
                                    {!isVsp &&
                                        <div class="cursor-pointer my-1 mx-1 d-flex" onClick={handelOpenToVsp}>
                                            <img src={NotVerifiedBlueLogo} width="24px" style={{ marginRight: '3px', }} />
                                            <label class="cursor-pointer text-nowrap">Pre-screened Only</label>
                                        </div>
                                    }
                                    {isVsp &&
                                        <div class="cursor-pointer my-1 mx-1 d-flex" onClick={handelOpenToVsp}>
                                            <img src={VerifiedBlueLogo} width="24px" style={{ marginRight: '3px' }} />
                                            <label class="cursor-pointer text-nowrap">Pre-screened Only</label>
                                        </div>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row mt-2 d-flex justify-content-center">
                    {[1].map((v) => {
                        return <>
                            <CandidateCard vsp={isVsp} year={year} salary={salary} maxCtc={maxCtc} immediate={immediate} location={location} term={term} searchTitle={searchTitle} sendDataToParent={handleDataFromChild} fullTime={fullTime} partTime={partTime} internship={internship} remote={remote} onSite={onSite} expStatus={expStatus} type="candidateList" />
                        </>
                    })}
                </div>
            </div>
            <section className="section full pt-4 d-none">
                <div className='container'>
                    <Link to="/" type="submit" className='my-2 text-white'>
                        <Button variant="primary mb-2"><FaArrowLeft style={{ width: '15px', height: '15px', marginRight: "7px" }} />Go to Dashboard
                        </Button>
                    </Link>
                    <Row>
                        <Col className='d-flex justify-content-between'>
                            <div>
                                <div className="d-flex align-items-center gap-2">
                                    <h1 className="title center text-dark" style={{ margin: "0" }}>Candidate Listing</h1>
                                    {/* <div>
                                        <Link to="" className='d-flex' onClick={handleToggleAccordion}>
                                            {activeKey === '0' ?
                                                <>
                                                    <Badge style={{ color: "#45a994" }} bg="none"><IoFunnel style={{ height: 'auto', width: '25px' }} /></Badge>
                                                </>
                                                :
                                                <>
                                                    <Badge style={{ color: "#45a994" }} bg="none"><IoFunnelOutline style={{ height: 'auto', width: '25px' }} /></Badge>
                                                </>

                                            }
                                        </Link>
                                    </div> */}

                                </div>
                                {role === "Candidate" ? <div className="section-title ps-0 text-dark">Top jobs matching your profile</div> : <div className="section-title ps-0 text-dark">Top Candidates</div>}
                                {/* <p className='text-dark'>We have considered your profi  le and the inputs given by you and have pulled some of the jobs from our recruitement partners.</p> */}
                            </div>
                            {/* <div>
                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='add-btn btn-secondary' variant="primary" onClick={handleAddNewJob}>Add</Button>
                                }
                            </div> */}
                        </Col>

                    </Row>
                    {/* <Row>
                        <Col>
                            <div className='empbtn d-flex'>
                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='emp-inner-btn add-btn btn-outline-primary mx-2' variant="outline-primary" onClick=""><span style={{ height: "19px" }}><ion-icon name="star-outline"></ion-icon></span>Top Rated</Button>
                                }

                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='emp-inner-btn add-btn btn-outline-primary mx-2' variant="outline-primary" onClick="{handleAddNewJob}"><span style={{ height: "19px" }}><ion-icon name="checkmark-done-circle-outline"></ion-icon></span>open To Join</Button>
                                }

                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='emp-inner-btn add-btn btn-outline-primary mx-2' variant="outline-primary" onClick="{handleAddNewJob}"><span style={{ height: "19px" }}><ion-icon name="color-wand-outline"></ion-icon></span>open To Switch</Button>
                                }

                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='emp-inner-btn add-btn btn-outline-primary mx-2' variant="outline-primary" onClick="{handleAddNewJob}"> ✔ Verified</Button>
                                }

                                {(role === 'Employer' || role === 'Admin') &&
                                    <Button className='emp-inner-btn add-btn btn-outline-primary mx-2' variant="outline-primary" onClick={handleToggleAccordion}><span className='' style={{ height: "19px" }}><ion-icon name="toggle-outline"></ion-icon></span>All Filters</Button>
                                }
                            </div>
                        </Col>
                    </Row> */}
                </div>
            </section>

            <section className="container section full d-none">
                <div className='container'>
                    {/* ///////////////////////////// search filter is hear///////////////////////////////////// */}
                    <Row>
                        <Col md="12">
                            {/* <div className='top-sec-heading'>
                            <h4>Filter By</h4>
                        </div> */}
                            <Accordion activeKey={activeKey}>
                                <Accordion.Item eventKey="0">
                                    {/* <Accordion.Header><h2>Filter By</h2></Accordion.Header> */}
                                    <Accordion.Body>
                                        <Row>
                                            <Col md="4">
                                                <Accordion style={{ borderTop: 'none' }}>
                                                    <Accordion.Item eventKey="0">
                                                        <Accordion.Header>Location</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form.Select aria-label="Default select example">
                                                                <option>Select your location</option>
                                                                <option value="1">Mumbai</option>
                                                                <option value="2">Navi Mumbai</option>
                                                                <option value="3">Pune</option>
                                                            </Form.Select>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                            <Col md="4">
                                                <Accordion>
                                                    <Accordion.Item eventKey="1">
                                                        <Accordion.Header>Job Type</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form className='wide-block py-3'>
                                                                <Form.Check
                                                                    label="Full time"
                                                                    name="group1"
                                                                    type='radio'
                                                                    id={`job-type-1`}
                                                                />
                                                                <Form.Check
                                                                    label="Part time"
                                                                    name="group1"
                                                                    type='radio'
                                                                    id={`job-type-2`}
                                                                />
                                                                <Form.Check
                                                                    label="Freelance"
                                                                    name="group1"
                                                                    type='radio'
                                                                    id={`job-type-3`}
                                                                />
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                            <Col md="4">
                                                <Accordion>
                                                    <Accordion.Item eventKey="2">
                                                        <Accordion.Header>Experience</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form className='wide-block py-3'>
                                                                <Form.Check
                                                                    label="Fresher"
                                                                    name="group2"
                                                                    type='radio'
                                                                    id={`xp-1`}
                                                                />
                                                                <Form.Check
                                                                    label="Intermediate"
                                                                    name="group2"
                                                                    type='radio'
                                                                    id={`xp-2`}
                                                                />
                                                                <Form.Check
                                                                    label="Expert"
                                                                    name="group2"
                                                                    type='radio'
                                                                    id={`xp-3`}
                                                                />
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="4">
                                                <Accordion>
                                                    <Accordion.Item eventKey="3">
                                                        <Accordion.Header>Salary</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form.Label>Range</Form.Label>
                                                            <Form.Range />
                                                            <Form className='wide-block py-3'>
                                                                <Form.Check
                                                                    label="3-5 LPA"
                                                                    name="group3"
                                                                    type='radio'
                                                                    id={`salary-1`}
                                                                />
                                                                <Form.Check
                                                                    label="5-7 LPA"
                                                                    name="group3"
                                                                    type='radio'
                                                                    id={`salary-2`}
                                                                />
                                                                <Form.Check
                                                                    label="7-10 LPA"
                                                                    name="group3"
                                                                    type='radio'
                                                                    id={`salary-3`}
                                                                />
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                            <Col md="4">
                                                <Accordion>
                                                    <Accordion.Item eventKey="4">
                                                        <Accordion.Header>Category</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form className='wide-block py-3'>
                                                                <Form.Check
                                                                    label="Developer"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`category-1`}
                                                                />
                                                                <Form.Check
                                                                    label="Finance"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`category-2`}
                                                                />
                                                                <Form.Check
                                                                    label="Design"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`category-3`}
                                                                />
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                            <Col md="4">
                                                <Accordion>
                                                    <Accordion.Item eventKey="5">
                                                        <Accordion.Header>Tags</Accordion.Header>
                                                        <Accordion.Body>
                                                            <Form className='wide-block py-3'>
                                                                <Form.Check
                                                                    label="Developer"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`Tags-1`}
                                                                />
                                                                <Form.Check
                                                                    label="Finance"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`Tags-2`}
                                                                />
                                                                <Form.Check
                                                                    label="Design"
                                                                    name="group3"
                                                                    type='checkbox'
                                                                    id={`Tags-3`}
                                                                />
                                                            </Form>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </Col>
                                        </Row>
                                        <div className='job-filter-box'>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    {/* ///////////////////////////// search filter END///////////////////////////////////// */}

                    <Row>
                        <Col md="12">
                            <div className='top-sec-heading'>
                                {(role === 'Candidate' || role === 'Admin') &&
                                    <h4>All {allFakeJobs.length !== null && allFakeJobs.length} jobs found</h4>
                                }
                                {/* {
                                    role === 'Employer' && <h4>All {allFakeJobs.filter(item => item.EmployerID === ID).length} jobs found</h4>
                                } */}

                            </div>
                            {isNewJob && (
                                <div className='py-4'>
                                    <h3>Create New Job</h3>
                                    <ul className="listview image-listview media">
                                        <li className='my-2 newJob'>
                                            <div className="item">
                                                <div className="imageWrapper in">
                                                    {/* <img src="" alt="" className="imaged w64" /> */}
                                                    <label htmlFor="jobImageInput" className="job-image-input rounded-circle position-relative">
                                                        {jobImage ? (
                                                            <img src={jobImage} alt="Uploaded" className="imaged w64" />
                                                        ) : (
                                                            <>
                                                                <input
                                                                    id="jobImageInput"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="position-absolute opacity-0"
                                                                    onChange={(e) => {
                                                                        const file = e.target.files[0];
                                                                        if (file) {
                                                                            const reader = new FileReader();
                                                                            reader.onload = (e) => {
                                                                                const imageUrl = e.target.result;
                                                                                setJobImage(imageUrl); // Assuming you have a state variable to store the image URL
                                                                            };
                                                                            reader.readAsDataURL(file);
                                                                        }
                                                                    }}
                                                                />Upload Image
                                                            </>
                                                        )}
                                                    </label>
                                                    <div className="in">
                                                        <div>
                                                            <div className="text-muted">
                                                                <Form.Select aria-label="Default select example"
                                                                    required
                                                                    onChange={(e) => setJobType(e.target.value)}
                                                                    isInvalid={validated && !jobType}
                                                                >
                                                                    <option selected disabled>job type</option>
                                                                    <option value="Full Time">Full Time</option>
                                                                    <option value="Part Time">Part Time</option>
                                                                    <option value="Internship">Internship</option>
                                                                </Form.Select>
                                                                <Form.Control.Feedback type="invalid">
                                                                    Please select Job Type.
                                                                </Form.Control.Feedback>
                                                            </div>
                                                            <Form.Control className='b-bottom'
                                                                required
                                                                type="text"
                                                                onChange={handleInputTitle}
                                                                value={jobTitle}
                                                                placeholder="Enter Job Title"
                                                                isInvalid={validated && !jobTitle}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please provide a Job Title.
                                                            </Form.Control.Feedback>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="in">
                                                    <div>
                                                        <div className="text-muted">
                                                            <Form.Select aria-label="Default select example"
                                                                onChange={(e) => setJobLocation(e.target.value)}
                                                                isInvalid={validated && !jobLocation}
                                                            >
                                                                <option selected disabled>Select Location</option>
                                                                <option value="Mumbai">Mumbai</option>
                                                                <option value="Navi Mumbai">Navi Mumbai</option>
                                                                <option value="Pune">Pune</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                Please select Job Location.
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <Form.Select aria-label="Default select example"
                                                            onChange={(e) => setJobCtc(e.target.value)}
                                                            isInvalid={validated && !jobCtc}
                                                        >
                                                            <option selected disabled>Select CTC range</option>
                                                            <option value="1 Lakh to 5 Lakh">1 Lakh to 5 Lakh</option>
                                                            <option value="6 Lakh to 10 Lakh">6 Lakh to 10 Lakh</option>
                                                            <option value="11 Lakh to 15 Lakh">11 Lakh to 15 Lakh</option>
                                                            <option value="15 Lakh and above">15 Lakh and above</option>
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Please select CTC Range.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                <div className="in">
                                                    <div>
                                                        <div className="text-muted">
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                value={numValueOpenings}
                                                                onChange={handleInputOpenings}
                                                                placeholder="Enter number of Openings"
                                                                isInvalid={validated && !numValueOpenings}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                Please provide a openings.
                                                            </Form.Control.Feedback>
                                                        </div>
                                                        <Form.Select aria-label="Default select example"
                                                            onChange={(e) => setJobEducation(e.target.value)}
                                                            isInvalid={validated && !jobEducation}
                                                        >
                                                            <option selected disabled>Selecte qualification</option>
                                                            <option value="12th Pass">12th Pass</option>
                                                            <option value="Diploma">Diploma</option>
                                                            <option value="ITI">ITI</option>
                                                            <option value="Graduation">Graduate</option>
                                                            <option value="Post Graduation">Post Graduate</option>
                                                            <option value="PHD">PHD</option>
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            Please select a required qualification.
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                                {/* <div className='d-flex align-items-center'>
                                                    </div> */}
                                                <div className="d-flex gap-1">
                                                    <Button noValidate validated={validated} onClick={handleSaveClick}>Save</Button>
                                                    <Button onClick={handleCancelClick}>Cancel</Button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            )}
                            {allFakeJobs.length === null ? <ShimmerJobs />
                                :
                                // <UserCardList
                                // // allFakeJobs={allFakeJobs}
                                // />
                                <ServerSide />
                            }
                        </Col>
                    </Row>
                </div>
            </section>
        </div >
    )
}
const mapStateToProps = ({ auth }) => {
    const { userData, role, fullName, ID, authToken } = auth

    return {
        userData,
        role,
        fullName,
        ID,
        authToken
    }
}

const mapDispatchToProps = {
    setToken,
    setSelectedJob
}

export default connect(mapStateToProps, mapDispatchToProps)(EmpCandidateList)
